import getRequest from './base/get';
import postRequest from './base/post';

export default {
  /**
   * Get Active Payment Gateway & Methods
   * Endpoint: /emsp/api/v1/adhoc/payment-gateway/active
   * @returns Axios Promise
   */
  getActivePaymentGateway: () => {
    return getRequest(`${process.env.REACT_APP_API_URL}emsp/api/v1/adhoc/payment-gateway/active`);
  },

  /**
   * Generate Checkout ID for adhoc payment registration
   * Endpoint: /emsp/api/v1/adhoc/payment/register
   * @returns Axios Promise
   */
  generateCheckoutId: () => {
    return postRequest(`${process.env.REACT_APP_API_URL}emsp/api/v1/adhoc/payment/register`);
  },

  /**
   * Confirm adhoc payment registration
   * Endpoint: /emsp/api/v1/adhoc/payment/register/confirm
   * @param data Request payload
   * @param data.checkoutId Checkout identifier
   * @returns Axios Promise
   */
  confirmRegistration: (data: { checkoutId: string }) => {
    return postRequest(`${process.env.REACT_APP_API_URL}emsp/api/v1/adhoc/payment/register/confirm`, data);
  },

  /**
   * Generate Apple Pay Checkout ID for adhoc payment registration
   * @returns Axios Promise
   */
  generateApplePayCheckoutId: () => {
    return postRequest(`${process.env.REACT_APP_API_URL}emsp/api/v1/adhoc/payment/register`, { isApplePay: true });
  },
};
